"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.BasketHelper = void 0;
var lodash_1 = require("lodash");
var money_1 = require("../../../core/money");
var rate_helper_1 = require("../../rate/model/rate.helper");
var model_1 = require("../../room/model");
var getZeroBasketValue = function (basket) {
    return {
        value: { amount: 0.0, currency: basket.currency },
        text: (money_1.MONEY_SYMBOLS[basket.currency] || basket.currency) + " 0"
    };
};
var getTotalOriginalPrice = function (basket) {
    if (lodash_1.get(basket.price, 'totalPrice.original.text')) {
        return basket.price.totalPrice.original;
    }
    return getZeroBasketValue(basket);
};
var getTotalConvertedPrice = function (basket) {
    if (lodash_1.get(basket.price, 'totalPrice.converted.text')) {
        return basket.price.totalPrice.converted;
    }
    return getZeroBasketValue(basket);
};
var getNumberOfAccommodation = function (basket) {
    return basket.rooms.reduce(function (acc, room) {
        for (var occId in room.occupancies) {
            var unitAccommodation = getUnitAccomodation(room.occupancies[occId].definition);
            var qty = room.occupancies[occId].selectedQuantity;
            acc += unitAccommodation * qty;
        }
        return acc;
    }, 0);
};
var getOccupancyOfAccommodation = function (basket) {
    return basket.rooms.reduce(function (acc, room) {
        return __spreadArrays(acc, Object.keys(room.occupancies).map(function (occId) {
            var accommodationOccupancy = room.occupancies[occId].definition.value;
            var qty = room.occupancies[occId].selectedQuantity;
            var accommodationOccupancyTotalQuantity = accommodationOccupancy.isDetailed
                ? {
                    adultCount: accommodationOccupancy.adultCount * qty,
                    childCount: accommodationOccupancy.childCount * qty,
                    infantCount: accommodationOccupancy.infantCount * qty
                } : {
                personCount: accommodationOccupancy.personCount * qty
            };
            return {
                id: occId,
                occupancy: accommodationOccupancyTotalQuantity
            };
        }));
    }, []);
};
var getUnitAccomodation = function (roomOccupancyDefinition) {
    var roomDetailedOccupancyTotal = roomOccupancyDefinition.value.adultCount + roomOccupancyDefinition.value.childCount + roomOccupancyDefinition.value.infantCount;
    // console.log('roomOccupancyDefinition value: ', roomOccupancyDefinition.value);
    return roomOccupancyDefinition.value.isDetailed
        ? roomDetailedOccupancyTotal
        : roomOccupancyDefinition.value.personCount;
};
var getQuantityByBasketRoom = function (room, occId) {
    if (occId === void 0) { occId = getFirstOccupancyIdInBasketRoom(room); }
    return room.occupancies[occId].selectedQuantity;
};
var getNumberOfRooms = function (basket) {
    return basket.rooms.reduce(function (acc, room) {
        return acc + Object.values(room.occupancies)
            .reduce(function (sum, occ) { return getQuantityByBasketRoom(room, "" + occ.occupancyId); }, 0);
    }, 0);
};
var getTaxesFormatted = function (basket) {
    if (basket.taxes.excluded.value.amount === 0) {
        return rate_helper_1.VAT_INCLUDED_MESSAGE;
    }
    return basket.taxes.excluded.text;
};
var getRoomCoverImage = function (basketRoom) {
    if (basketRoom.pictures.length) {
        return basketRoom.pictures[0].templates.find(function (t) { return t.name === model_1.RoomTemplateImage.XLarge; });
    }
    return {};
};
var getFirstOccupancyIdInBasketRoom = function (basketRoom) {
    var occupancyIds = Object.keys(basketRoom.occupancies);
    return occupancyIds && occupancyIds[0];
};
var getRoomTotalPrice = function (basketRoom) {
    var occId = getFirstOccupancyIdInBasketRoom(basketRoom);
    var occupancy = basketRoom.occupancies[occId];
    return rate_helper_1.RateHelper.multiplyMoney(occupancy.price.converted, occupancy.selectedQuantity);
};
exports.BasketHelper = {
    getTotalOriginalPrice: getTotalOriginalPrice,
    getTotalConvertedPrice: getTotalConvertedPrice,
    getNumberOfAccommodation: getNumberOfAccommodation,
    getOccupancyOfAccommodation: getOccupancyOfAccommodation,
    getNumberOfRooms: getNumberOfRooms,
    getTaxesFormatted: getTaxesFormatted,
    getRoomCoverImage: getRoomCoverImage,
    getFirstOccupancyIdInBasketRoom: getFirstOccupancyIdInBasketRoom,
    getQuantityByBasketRoom: getQuantityByBasketRoom,
    getRoomTotalPrice: getRoomTotalPrice
};
//# sourceMappingURL=basket.helper.js.map